import React from 'react';
import Styles from './Page.scss';

interface IPageProps {
    children: React.ReactNode;
}

const Page = (props: IPageProps) => {
    return <div className={Styles.page}>{props.children}</div>;
};
export default Page;
